module.exports = __webpack_public_path__ + "img/fiji_oak_bfusa_list.14e23c64.jpg";